<template>
  <v-container>
    <v-col cols="12" md="6">
      <!-- style="width: 50%" -->
      <v-row class="headerTable-div2">
        <v-col md="4" sm="12">
          <h3 class="custom-header main-color">{{ title }}</h3>
        </v-col>
      </v-row>
      <!-- Children -->
      <v-col
        md="6"
        cols="12"
        style="padding-left: 0 px !important; padding-right: 0 px !important"
        class="text-right btn-container container"
      >
        <v-btn
          :class="selectedStudentID == child.id ? 'isBlue' : ''"
          v-for="child in children"
          :key="child"
          rounded
          color="#EFEFEF"
          dark
          style="
            margin: 10px;
            margin-left: 0px;
            text-transform: capitalize;
            color: #979797;
            width: auto;
          "
          @click="whoSelected(child)"
        >
          {{ child.name }}
        </v-btn>
      </v-col>
      <!-- Children -->
      <v-row>
        <v-col style="position: relative">
          <v-data-table
            :headers="table.headersData"
            :items="dataTable"
            :options.sync="options"
            class="elevation-1 orderTable custom-padding"
            item-key="id"
            hide-default-footer
          >
          </v-data-table>

          <div class="text-center pt-2">
            <v-pagination
              v-model="pagination.page"
              :length="pagination.length"
              :circle="true"
              :page="pagination.page"
              :total-visible="pagination.totalVisible"
              next-icon="mdi-menu-right"
              prev-icon="mdi-menu-left"
            ></v-pagination>
          </div>
        </v-col>
        <EmptySpace></EmptySpace>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import EmptySpace from "../components/EmptySpace.vue";
import HttpService from "../services/HttpService.js";

export default {
  components: {
    EmptySpace,
  },
  props: ["order"],

  data() {
    return {
      children: 0,
      dataTable: [],
      selectedStudentID: -1,
      // title: "Transfers",
      title: this.$i18n.t("Transfers"),
      pagination: {
        page: 1,
        length: 0,
        totalVisible: "",
      },
      options: {
        itemsPerPage: 15,
      },
      table: {
        headersData: [
          {
            text: this.$i18n.t("Points"),
            value: "points",
            sortable: false,
            width: "60px",
          },
          {
            text: this.$i18n.t("Date & Time"),
            value: "created_at",
            sortable: false,
          },
          {
            text: this.$i18n.t("Transferd by"),
            value: "transferd_by",
            sortable: false,
          },
        ],
      },
    };
  },
  methods: {
    whoSelected(child) {
      console.log(child);
      this.selectedStudentID = child.id;
      this.getAllTransfers();
    },

    getChildren() {
      HttpService.get("wallet/myChildren", "", true).then((response) => {
        this.children = response.data.data;
        this.selectedStudentID = this.children[0].id;
        this.getAllTransfers();
      });
    },

    setPaginationParameters(response) {
      console.log("response = ", response);

      this.pagination.length = response.data.data.allTransfers.last_page;
      if (this.pagination.length > 5) this.pagination.totalVisible = 5;
    },

    getAllTransfers() {
      let queryString = "?page=" + this.pagination.page;
      HttpService.get(
        "wallet/allTransfers/" + this.selectedStudentID,
        queryString,
        true
      ).then((response) => {
        // ------------------ //
        // HttpService.get(
        //   "wallet/allTransfers/" + this.selectedStudentID,
        //   "",
        //   true
        // ).then((response) => {
        this.setPaginationParameters(response);
        this.dataTable = response.data.data.allTransfers.data;
        console.log("response", response);
      });
    },
  },
  created() {
    this.getChildren();
  },

  watch: {
    "pagination.page": {
      handler() {
        this.getAllTransfers();
      },
      deep: true,
    },
  },
  mounted() {},
};
</script>

<style>

.custom-padding td,
.custom-padding th {
  padding: 0px !important;
}

.container {
  padding-left: 0 px !important;
  padding-right: 0 px !important;
  /* border: 1px solid; */
}

.btn-container {
  display: flex;
  /* ممكن تضيف خصائص ترتيب كمان */
  justify-content: flex-start; /* أو center / space-between / space-around */
  /* gap: 10px; */
  /* مسافة بين الأزرار */
}
.isBlue {
  color: #5a86ff !important;
  background-color: rgba(90, 134, 255, 0.3) !important;
}

.searchInput {
  border-radius: 30px;
  padding: 10px;
  /* width: 793px;
  height: 51px; */
}

/* ===============================
   small Mobile 
   =============================== */
@media (max-width: 320px) {
  /* CSS for very small phones */
  .v-data-table__wrapper th, .v-data-table__wrapper td{
    font-size: 15;
  }
}

/* ===============================
   Mobile 
   =============================== */
@media (max-width: 480px) {
  /* CSS for standard phones */
}

/* ===============================
   Large Mobile 
   =============================== */
@media (max-width: 576px) {
  /* CSS for large phones */
}

/* ===============================
   Tablets 
   =============================== */
@media (max-width: 768px) {
  /* CSS for tablets */
}

/* ===============================
   Small Laptops 
   =============================== */
@media (max-width: 992px) {
  /* CSS for small laptops */
}

/* ===============================
   Normal Desktops 
   =============================== */
@media (max-width: 1200px) {
  /* CSS for normal screens */
}

/* ===============================
   Large Screens 
   =============================== */
@media (max-width: 1400px) {
  /* CSS for large screens */
}

/* ===============================
   Extra Large – 4K Screens
   =============================== */
@media (min-width: 1600px) {
  /* CSS for 4K screens */
}
</style>
